import type { AccountInfo, AuthenticationResult } from "@azure/msal-browser";

/**
 * GEN-3604 — qual conta Microsoft vai para o backend no login SSO.
 *
 * O `idToken` que enviamos é o da conta que a pessoa ESCOLHEU no popup. Antes, e-mail/nome/checksum
 * saíam de `accounts[0]` (a primeira conta no cache do MSAL) — com mais de uma conta logada no
 * navegador, o backend (que agora valida o ID token de verdade, F0.1) via um token de uma pessoa e
 * um e-mail de outra e recusava o login. A conta certa é a que o próprio `loginPopup` devolve.
 *
 * O fallback para `accounts[0]` só vale quando há EXATAMENTE uma conta em cache —
 * aí não há o que errar. Com várias contas e o popup sem `account`, escolher a primeira é apostar;
 * quando a aposta erra, o backend recusa com um erro genérico e a pessoa não entende o motivo. Melhor
 * dizer o que fazer. Popup cancelado/erro do MSAL (sem resultado) segue silencioso, como antes.
 */
export const CONTA_MICROSOFT_AMBIGUA =
  "Não foi possível identificar a conta Microsoft escolhida. Feche as outras sessões Microsoft e tente de novo.";

export interface ContaParaLogin {
  account: AccountInfo | undefined;
  /** Mensagem para a tela quando o popup voltou mas não dá para saber qual conta é a escolhida. */
  erro?: string;
}

export function contaParaLogin(
  resultado: Pick<AuthenticationResult, "account"> | null | undefined,
  accounts: readonly AccountInfo[]
): ContaParaLogin {
  if (resultado?.account) return { account: resultado.account };
  if (accounts.length === 1) return { account: accounts[0] };
  if (resultado && accounts.length > 1) return { account: undefined, erro: CONTA_MICROSOFT_AMBIGUA };
  return { account: undefined };
}
